import Vue from 'vue';
import DeviceSize from './device-size';

Vue.mixin(DeviceSize);